import axios from 'axios'

export default {
    GETAPPCONFIGRATION ({ commit }) {
        return axios.get('/freepreview/getAllAppConfiguration').then((response) => {
            const { data: { data } } = response
            commit('setAllConfgirations', {config: data})
            // Get Gifting Text
            let giftingTitle = data.filter(conf => {
                return conf.key === 'Gift_Link_Text'
            })
            if (giftingTitle && giftingTitle.length >= 0) {
                if (giftingTitle[0].value) {
                    commit('setGiftingText', giftingTitle[0].value)
                } else {
                    commit('setGiftingText', 'Give the gift of TONE')
                }
            } else {
                commit('setGiftingText', 'Give the gift of TONE')
            }
            // Custom Unauth Banner Enabled/Disabled
            let customBanner = data.filter(conf => {
                return conf.key === 'ShowCustomUnauthBanner'
            })
            if (customBanner && customBanner.length >= 0) {
                if (customBanner[0].value === '1') {
                    commit('setShowCustomUnauthBanner', true)
                } else {
                    commit('setShowCustomUnauthBanner', false)
                }
            } else {
                commit('setShowCustomUnauthBanner', false)
            }
            // Get Custom Unauth Banner Text
            let customBannerText = data.filter(conf => {
                return conf.key === 'CustomUnauthBannerText'
            })
            if (customBannerText && customBannerText.length >= 0) {
                if (customBannerText[0].value) {
                    commit('setUnauthBannerText', customBannerText[0].value)
                } else {
                    commit('setUnauthBannerText', '')
                }
            } else {
                commit('setUnauthBannerText', '')
            }
            // Get Custom Unauth Banner Link
            let customBannerLink = data.filter(conf => {
                return conf.key === 'CustomUnauthBannerLink'
            })
            if (customBannerLink && customBannerLink.length >= 0) {
                if (customBannerLink[0].value) {
                    commit('setUnauthBannerLink', customBannerLink[0].value)
                } else {
                    commit('setUnauthBannerLink', '')
                }
            } else {
                commit('setUnauthBannerLink', '')
            }
            // Check Site Maintenance Status
            let siteStatus = data.filter(conf => {
                return conf.key === 'EnableMaintenancePage'
            })
            if (siteStatus && siteStatus.length >= 0) {
                if (siteStatus[0].value === '1') {
                    commit('setMaintenanceStatus', true)
                } else {
                    commit('setMaintenanceStatus', false)
                }
            } else {
                commit('setMaintenanceStatus', false)
            }
            // Enable Corporate Livestraeming
            let corpLiveStreamStatus = data.filter(conf => {
                return conf.key === 'EnableCorporateLiveStreaming'
            })
            if (corpLiveStreamStatus && corpLiveStreamStatus.length >= 0) {
                if (corpLiveStreamStatus[0].value === '1') {
                    commit('SetCorporateLiveStreamFlag', 1)
                } else {
                    commit('SetCorporateLiveStreamFlag', 0)
                }
            } else {
                commit('SetCorporateLiveStreamFlag', 0)
            }
            // Set Free Preview Status EnableCorporateLiveStreaming
            let freePreviewStatus = data.filter(conf => {
                return conf.key === 'FreePreviewService'
            })
            if (freePreviewStatus && freePreviewStatus.length >= 0) {
                if (freePreviewStatus[0].value === '1') {
                    commit('SetDefaultPreviewStatus', 1)
                } else {
                    commit('SetDefaultPreviewStatus', 0)
                }
            } else {
                commit('SetDefaultPreviewStatus', 0)
            }
            // Set Event Switch Time (Default)
            let swithTime = data.filter(conf => {
                return conf.key === 'DefaultEventJoiningSwitch'
            })
            if (swithTime && swithTime.length >= 0) {
                commit('setEventJoinSwitch', swithTime[0].value)
            } else {
                commit('setEventJoinSwitch', 0)
            }
            // Set Free Days
            let totalTrialDys = data.filter(conf => {
                return conf.key === 'TrialDays'
            })
            if (totalTrialDys && totalTrialDys.length >= 0) {
                commit('setTotalTrialDays', totalTrialDys[0].value)
            } else {
                commit('setTotalTrialDays', 0)
            }
            // Paid Membership Status across site
            let paidMemberService = data.filter(conf => {
                return conf.key === 'PaidMembershipService'
            })
            if (paidMemberService && paidMemberService.length >= 0) {
                if (paidMemberService[0].value === '1') {
                    commit('setPaidMembershipFlag', 1)
                } else {
                    commit('setPaidMembershipFlag', 0)
                }
            } else {
                commit('setPaidMembershipFlag', 0)
            }
            // Charity Section on profile page
            let charitySection = data.filter(conf => {
                return conf.key === 'ShowProfileCharitySection'
            })
            if (charitySection && charitySection.length >= 0) {
                if (charitySection[0].value === '1') {
                    commit('setProfileCharitySectionFlag', 1)
                } else {
                    commit('setProfileCharitySectionFlag', 0)
                }
            } else {
                commit('setProfileCharitySectionFlag', 0)
            }
            // Auth Left Top Banner Message
            let authBannerMessage = data.filter(conf => {
                return conf.key === 'RegularAuthLeftTopBannerMessage'
            })
            if (authBannerMessage && authBannerMessage.length >= 0) {
                commit('setAuthLeftTopBannerMessage', authBannerMessage[0].value)
            } else {
                commit('setAuthLeftTopBannerMessage', null)
            }
            // Auth Left Top Banner Url
            let authBannerUrl = data.filter(conf => {
                return conf.key === 'RegularAuthLeftTopBannerUrl'
            })
            if (authBannerUrl && authBannerUrl.length >= 0) {
                commit('setAuthLeftTopBannerUrl', authBannerUrl[0].value)
            } else {
                commit('setAuthLeftTopBannerUrl', null)
            }
            // Unauth Findout more Url
            let findoutMoreUrl = data.filter(conf => {
                return conf.key === 'UnauthFindMoreLinkUrl'
            })
            if (findoutMoreUrl && findoutMoreUrl.length >= 0) {
                commit('setUnauthFindMoreUrl', findoutMoreUrl[0].value)
            } else {
                commit('setUnauthFindMoreUrl', null)
            }
            // Show Event Participant Count
            let showParticipantCount = data.filter(conf => {
                return conf.key === 'ShowEventParticipantCount'
            })
            if (showParticipantCount && showParticipantCount.length >= 0) {
                if (showParticipantCount[0].value === '1') {
                    commit('setShowParticipantFlag', 1)
                } else {
                    commit('setShowParticipantFlag', 0)
                }
            } else {
                commit('setShowParticipantFlag', 0)
            }
            // Gifting Link Status across site
            let giftingLinksStatus = data.filter(conf => {
                return conf.key === 'HideGiftingLinksAcrossSite'
            })
            if (giftingLinksStatus && giftingLinksStatus.length >= 0) {
                if (giftingLinksStatus[0].value === '1') {
                    commit('setGiftingLinksStatus', 1)
                } else {
                    commit('setGiftingLinksStatus', 0)
                }
            } else {
                commit('setGiftingLinksStatus', 0)
            }
            // Set MessageBoard Duration
            let totalDuration = data.filter(conf => {
                return conf.key === 'BannerMessageDuration'
            })
            if (totalDuration && totalDuration.length >= 0) {
                commit('setMessageDuration', parseInt(totalDuration[0].value))
            } else {
                commit('setMessageDuration', 0)
            }
            // Set Live Streaming Status/URL
            let amcStreamingURL = data.filter(conf => {
                return conf.key === 'CorpLiveStreamingURL'
            })
            if (amcStreamingURL && amcStreamingURL.length > 0) {
                commit('setCorpStreamingURL', amcStreamingURL[0].value)
            } else {
                commit('setCorpStreamingURL', null)
            }
            let liveStreamingStatus = data.filter(conf => {
                return conf.key === 'EnableLiveStreaming'
            })
            let liveStreamingURL = data.filter(conf => {
                return conf.key === 'LiveStreamingURL'
            })
            if (liveStreamingStatus && liveStreamingStatus.length > 0 && liveStreamingURL && liveStreamingURL.length > 0) {
                if (liveStreamingStatus[0].value === '1' && liveStreamingURL[0].value.length > 0) {
                    commit('setLiveStreamingStatus', 1)
                    commit('setLiveStreamingURL', liveStreamingURL[0].value)
                } else {
                    commit('setLiveStreamingStatus', 0)
                    commit('setLiveStreamingURL', null)
                }
            } else {
                commit('setLiveStreamingStatus', 0)
                commit('setLiveStreamingURL', null)
            }
        }, (err) => {
            commit('setLiveStreamingStatus', 0)
            commit('setLiveStreamingURL', null)
            console.log('err ', err)
        })
    },
    GETPRESSRELEASES ({ commit }) {
        return axios.get(`feedback/getPressPageContents`).then((response) => {
            const { data: { data } } = response
            commit('setPressReleaseData', {pressReleases: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    // Prerender Cache
    CACHEPAGE ({ commit }, urlToCache) {
        let payload = {
            prerenderToken: 'RUaZ4IiogChhTF802Xk1',
            url: urlToCache
        }
        return axios.post(`https://api.prerender.io/recache`, payload).then((response) => {
            console.log(`${urlToCache} successfully cached!`)
        }, (err) => {
            console.log('err ', `${err} : Page coudn't be cached`)
        })
    },
    GETMESSAGEBOARD ({ commit }, corpId) {
        return axios.get(`home/getAllBanners/${corpId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setMessageBoard', {messages: data.payload})
            } else {
                commit('setMessageBoard', {messages: null})
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETALLARTICLES ({ commit }) {
        return axios.get(`user/findAllToneArticles`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setAllArticles', {articles: data.payload})
            } else {
                commit('setAllArticles', {articles: null})
            }
        }, (err) => {
            commit('setAllArticles', {articles: null})
            console.log('err ', err)
        })
    },
    GETSELECTEDARTICLE ({ commit }, articleId) {
        return axios.get(`user/findToneArticleById/${articleId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setSelectedArticle', {article: data.payload})
            } else {
                commit('setSelectedArticle', {article: null})
            }
        }, (err) => {
            commit('setSelectedArticle', {article: null})
            console.log('err ', err)
        })
    },
    GETFAQS ({ commit }) {
        return axios.get(`common/getAllFaqs`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setFaqs', {faqs: data.payload})
            } else {
                commit('setFaqs', {faqs: null})
            }
        }, (err) => {
            commit('setFaqs', {faqs: null})
            console.log('err ', err)
        })
    },
    GETSTAFFMEMBERS ({ commit }) {
        return axios.get(`common/getAllStaff`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setMembers', {members: data.payload})
            } else {
                commit('setMembers', {members: null})
            }
        }, (err) => {
            commit('setMembers', {members: null})
            console.log('err ', err)
        })
    },
    GET_ADVISORY_BOARD ({ commit }, groupName) {
        return axios.get(`/common/getAdvisoryBoard/${groupName}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setAdvisoryBoard', {adBoard: data.payload})
                console.log('GET_PODCAST_FOR_SERVICE - DATA FOUND  >>>>>>>>>>>>>>>>>>> data.payload ', data.payload)
            } else {
                commit('setAdvisoryBoard', {adBoard: null})
                console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> data.payload ', data.payload)
            }
        }, (err) => {
            console.log('err ', err)
            commit('setAdvisoryBoard', {adBoard: null})
        })
    },
    DECODE_REQUEST_DATA ({ commit }, base64Data) {
        return axios.get(`/common/getDecodedData/${base64Data}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setRequestDecodedData', {decodedData: data.payload})
                console.log('DECODE_REQUEST_DATA - DATA FOUND  >>>>>>>>>>>>>>>>>>> data.payload ', data.payload)
            } else {
                commit('setRequestDecodedData', {decodedData: null})
                console.log('DECODE_REQUEST_DATA -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> data.payload ', data.payload)
            }
        }, (err) => {
            console.log('ERROR INSIDE : err ', err)
            commit('setRequestDecodedData', {decodedData: null})
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/configuration/actions.js